import { CREATE_CLIENT_FAIL, 
  CREATE_CLIENT_SUCCESS, 
  DELETE_ALL_CLIENT_FAIL, 
  DELETE_ALL_CLIENT_SUCCESS, 
  DELETE_CLIENT_SUCCESS, 
  LIST_CLIENT_FAIL,
   LIST_CLIENT_SUCCESS, 
   LIST_MANAGER_FAIL, 
   LIST_MANAGER_SUCCESS, 
   SEARCH_CLIENT_FAIL, 
   SEARCH_CLIENT_SUCCESS, 
   SHOW_CLIENT_FAIL, 
   SHOW_CLIENT_SUCCESS, 
   UPDATE_CLIENT_FAIL, 
   UPDATE_CLIENT_SUCCESS, 
   UPLOAD_EXCEL_CLIENT_FAIL, 
   UPLOAD_EXCEL_CLIENT_SUCCESS } from "./type"
  import {
    SET_MESSAGE,
  } from "../message/type"
  import UserService from "../../../services/user.service"
   

  export const checkResetToken = (token) => (dispatch) => {
   
    return UserService.checkresetToken(token).then(
      (response) => {
       console.log('response jxt ===', response)
        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: 'success',
            status: response
          },
        });
  
        return Promise.resolve()
      },
      (error) => {
        
        
        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: 'failed',
            status: 404
          },
        });
  
        return Promise.reject()
      }
    )
  }
  export const create = (data) => (dispatch) => {
    
    return UserService.createClient(data).then(
      (response) => {
        dispatch({
          type: CREATE_CLIENT_SUCCESS,
          payload: response.user
        })
        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: response.message,
            status: response.status
          },
        });
  
        return Promise.resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString()
  
        dispatch({
          type: CREATE_CLIENT_FAIL
        })

        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: message,
            status: error.status
          },
        });
  
        return Promise.reject()
      }
    )
  }

  
  export const getAllClients = (page,size) => (dispatch) => {
    return UserService.allClients(page,size).then(
      (response) => {
        
        dispatch({
          type: LIST_CLIENT_SUCCESS,
          payload: response.data
        })
        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: response.message,
            status: response.status
          },
        });
  
        return Promise.resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString()
  
        dispatch({
          type: LIST_CLIENT_FAIL
        })

        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: message,
            status: error.status
          },
        });
  
        return Promise.reject()
      }
    )
  }
  export const getoneClient = (userId) => (dispatch) => {
    return UserService.findOne(userId).then(
      (response) => {
      
        dispatch({
          type: SHOW_CLIENT_SUCCESS,
          payload: response.data
        })
        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: response.message,
            status: response.status
          },
        });
  
        return Promise.resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString()
  
        dispatch({
          type: SHOW_CLIENT_FAIL
        })

        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: message,
            status: error.status
          },
        });
  
        return Promise.reject()
      }
    )
  }
 
  export const getManagersByTenant = () => (dispatch) => {
    return UserService.findManagersByTenant().then(
      (response) => {
        dispatch({
          type: LIST_MANAGER_SUCCESS,
          payload: response.data
        })
        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: response.message,
            status: response.status
          },
        });
        console.log('190--------------------------------------------payload', response.data)
        
        return Promise.resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString()
  
        dispatch({
          type: LIST_MANAGER_FAIL
        })

        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: message,
            status: error.status
          },
        });
  
        return Promise.reject()
      }
    )
  }

  export const searchClients = (searchString) => (dispatch) => {
    return UserService.search(searchString).then(
      (response) => {
        
        dispatch({
          type: SEARCH_CLIENT_SUCCESS,
          payload: response.data
        })
        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: response.message,
            status: response.status
          },
        });
  
        return Promise.resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString()
  
        dispatch({
          type: SEARCH_CLIENT_FAIL
        })

        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: message,
            status: error.status
          },
        });
  
        return Promise.reject()
      }
    )
  }


  export const removeClient = (userId) => (dispatch) => {
    return UserService.deleteClient(userId).then(
      (response) => {
        
        dispatch({
          type: DELETE_CLIENT_SUCCESS,
          payload: userId
        })
        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: response.message,
            status: response.status
          },
        });
  
        return Promise.resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString()
  
        dispatch({
          type: DELETE_ALL_CLIENT_FAIL
        })

        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: message,
            status: error.status
          },
        });
  
        return Promise.reject()
      }
    )
  }

  export const removeAllClient = () => (dispatch) => {
    return UserService.deleteAll().then(
      (response) => {
        
        dispatch({
          type: DELETE_ALL_CLIENT_SUCCESS,
          payload: response
        })
        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: response.message,
            status: response.status
          },
        });
  
        return Promise.resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString()
  
        dispatch({
          type: DELETE_ALL_CLIENT_FAIL
        })

        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: message,
            status: error.status
          },
        });
  
        return Promise.reject()
      }
    )
  }


  export const updateClient = (data, userId) => (dispatch) => {
    return UserService.updateClient(data, userId).then(
      (response) => {
       
        dispatch({
          type: UPDATE_CLIENT_SUCCESS,
          payload: userId
        })
        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: response.message,
            status: response.status
          },
        });
  
        return Promise.resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString()
  
        dispatch({
          type: UPDATE_CLIENT_FAIL
        })

        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: message,
            status: error.status
          },
        });
  
        return Promise.reject()
      }
    )
  }


  export const uploadExcel = (data) => (dispatch) => {
   
    return UserService.uploadExcel(data).then(
      (response) => {
        
        dispatch({
          type: UPLOAD_EXCEL_CLIENT_SUCCESS,
          payload: response.data
        })
        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: response.message,
            status: response.status
          },
        });
  
        return Promise.resolve()
      },
      (error) => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString()
  
        dispatch({
          type: UPLOAD_EXCEL_CLIENT_FAIL
        })

        dispatch({
          type: SET_MESSAGE,
          payload:{
            message: message,
            status: error.status
          },
        });
  
        return Promise.reject()
      }
    )
  }
